const en = {
  // Nav
  nav_about: "About",
  nav_skills: "Skills",
  nav_exp: "Experience",
  nav_work: "Work",
  nav_contact: "Contact",
  nav_cta: "Let's talk",

  // Hero
  hero_status: "Available for new projects",
  hero_hello: "Hi, I'm",
  hero_iam: "I build",
  hero_sub:
    "Frontend developer with 5 years building enterprise Angular applications. Passionate about efficient, attractive interfaces, obsessing over performance and a smooth, intuitive user experience.",
  hero_cta1: "Let's work together",
  hero_cta2: "See my journey",
  stat_years: "Years of experience",
  stat_proj: "Enterprise projects",
  stat_tech: "Technologies mastered",
  hero_focus_l: "Now focusing on",
  hero_focus: "integrating AI into real-world apps and intelligent products",

  // Roles (rotating word)
  roles: [
    "Frontend with Angular",
    "enterprise web apps",
    "AI-assisted tooling",
    "clean architectures",
  ],

  // Companies strip
  strip_label: "Companies I've built for",

  // About
  about_ey: "Get to know me",
  about_h: "About me",
  about_c1t: "Education",
  about_c1s: "Cross-platform App Development · DAM",
  about_c2t: "University",
  about_c2s: "Universitat Oberta de Catalunya",
  about_lead_a: "Developer focused on ",
  about_lead_b: "clean, high-performance digital products",
  about_p1:
    "Hi, my name is León. I'm a developer passionate about creating <b>efficient and attractive user interfaces</b>, focused on <b>performance optimization</b> and delivering an <b>intuitive, functional and agile</b> user experience.",
  about_p2:
    "I consider myself a <b>creative and proactive</b> person, always <b>expanding and updating my skills</b> as a developer and committed to a <b>job well done</b>. I enjoy working in a team and taking on <b>new challenges</b> that let me grow professionally.",
  about_p3:
    "I'm eager to bring my experience, <b>learn alongside my colleagues</b> and apply my <b>creativity</b> to every project that comes my way.",
  about_focus: "Leveling up in AI integration to ship smarter, faster products",
  proj_paco_title: "VSCode Extension · UNIR",
  proj_paco:
    "VSCode extension for AI-assisted Angular code generation via MCP.",
  proj_laminarra_title: "Lamiñarra",
  proj_laminarra:
    "Digital editorial platform for books — Astro + custom CMS with MongoDB and Cloudinary integration.",

  // Skills
  sk_ey: "What I work with",
  sk_h: "My skills",
  sk_front: "Frontend development",
  sk_tools: "Tools & integration",
  sk_ia: "AI",
  sk_back: "Backend",

  // Experience timeline
  ex_ey: "Work timeline",
  ex_h: "My journey",
  ex_now: "Now",
  ex1_role: "Frontend Developer · UNIR, Architecture Dept.",
  ex1_date: "Dec. 2025 → Present",
  ex1_desc:
    "AI-driven frontend development, integrations and componentization for internal projects at UNIR, Architecture Department.",
  ex1_b1:
    "VSCode extension for AI-assisted code generation connected to component documentation via MCP.",
  ex1_b2:
    "Claude SDK integration for AI-driven flows, combined with deterministic generation (Nx templates) and integrated terminal (PTY).",
  ex1_b3:
    "Building MCP and MCP-stdio servers to connect AI models with client APIs and internal systems.",
  ex1_b4:
    "DocuSign API integration for a custom digital signature component for UNIR clients.",
  ex2_role: "Frontend Developer · Atmira (Consulting)",
  ex2_date: "Oct. 2024 → Nov. 2025",
  ex2_desc:
    "AI-powered toolkit for the university's teaching department at UNIR.",
  ex2_b1:
    "AI tooling platform development that generates content for the teaching department.",
  ex2_b2: "Monorepo architecture with Nx, Angular 18/20 and signals.",
  ex2_b3: "Componentization in Storybook and creation of reusable components.",
  ex3_role: "Frontend Developer · MICAELA, Gob. España (SGD)",
  ex3_date: "Jul. 2024 → Sept. 2024",
  ex3_desc:
    "Built the public website of the MICAELA project, a scientific and energy platform for the Spanish Government.",
  ex3_b1: "Greenfield project built from scratch in Angular v17.",
  ex3_b2: "Development and maintenance of micro-frontends.",
  ex3_b3: "Component library built with Storybook.",
  ex4_role: "Frontend Developer · AEGON, Private Area (Insurance)",
  ex4_date: "Nov. 2022 → Jun. 2024",
  ex4_desc:
    "Web application for the customer area of Aegon Spain insurance, plus management of a customized component library.",
  ex4_b1: "Development & maintenance of the web in Angular v8 and v17.",
  ex4_b2: "Development & maintenance of web micro-frontends.",
  ex4_b3: "Component library built with Storybook.",
  ex5_role: "Frontend Developer · Staff-IT, Internal Project (ERP)",
  ex5_date: "Mar. 2022 → Oct. 2022",
  ex5_desc:
    "Staff-IT, an internal web product for managing the company's own employees and clients.",
  ex5_b1: "New features and maintenance in Angular v12.",
  ex5_b2: "Integration between web application modules.",
  ex5_b3: "Maintenance focused on Angular hexagonal architecture.",

  // Portfolio
  pf_ey: "My recent work",
  pf_h: "Portfolio",
  pf_demo: "Demo ↗",
  pf_laminarra_desc:
    "Full-stack editorial platform for books. Astro frontend, NestJS API, MongoDB Atlas, Cloudinary for media, Google OAuth authentication and a custom admin dashboard to manage all content and database.",
  pf_solar_desc:
    "Corporate website for a solar panel maintenance company (Navarra). Bilingual HTML/CSS/JS static site with Bootstrap and Formspree contact forms.",
  pf_shot_desc:
    "Python desktop tool to capture full-page screenshots in desktop, tablet and mobile formats — with mockup frames and automatic URL crawling.",
  pf_lib_desc:
    "Custom Angular component library with Storybook documentation. Reusable UI components with Sass theming and strict TypeScript.",

  // Contact
  ct_ey: "Get in touch",
  ct_h: "Let's build something",
  ct_sub:
    "Have a project in mind or just want to say hi? Tell me about it. I usually reply within a day.",
  ct_phone: "Phone",
  ct_send: "Send message",
  ct_sent: "Sent!",
  ph_name: "Your name or company",
  ph_email: "Email",
  ph_msg: "Tell me about your project...",

  // Footer
  ft_rights: "© 2026 León Arellano · Frontend Developer",
  ft_top: "Back to top ↑",
};

export default en;
